export enum AccessLevel {
  USER = 5,
  ADMINISTRATOR = 10,
}
